import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { FC } from 'react';

import RemoveDepartmentAdminDialogButton from './RemoveDepartmentAdminDialogButton';

const UpdateDepartmentAdminDialog: FC<{
  id: string;
  fullName: string;
  role: string;
  onClose: () => void;
}> = ({ id, fullName, role, onClose }) => {
  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Update Department Admin</DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <p>
            The admin name is {fullName} and their role is {role}
          </p>
          <RemoveDepartmentAdminDialogButton id={id} onComplete={onClose} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UpdateDepartmentAdminDialog;
